var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessengerRedesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.386,
    height: 55.359,
    viewBox: "0 0 55.386 55.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.203,
    cy: 1.022,
    r: 1.099,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5697fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8936f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#dd537e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e06f62"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements",
    "data-name": "Graphic Elements",
    transform: "translate(-0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bubble",
    d: "M27.69,0C12.09,0,0,11.4,0,26.861A26.258,26.258,0,0,0,8.686,46.729a2.237,2.237,0,0,1,.755,1.6l.147,4.887a2.221,2.221,0,0,0,3.111,1.96l5.495-2.427a2.21,2.21,0,0,1,1.482-.109,30.162,30.162,0,0,0,8.014,1.086c15.6,0,27.692-11.4,27.692-26.861S43.29,0,27.69,0Z",
    transform: "translate(0.004)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bolt",
    d: "M20.207,50.422l8.145-12.907a4.154,4.154,0,0,1,6.005-1.086l6.467,4.849a1.662,1.662,0,0,0,2,0l8.731-6.657A1.319,1.319,0,0,1,53.47,36.37L45.325,49.277a4.154,4.154,0,0,1-6.005,1.086l-6.461-4.827a1.661,1.661,0,0,0-1.993.033l-8.747,6.6a1.319,1.319,0,0,1-1.911-1.748Z",
    transform: "translate(-9.144 -15.704)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerRedesign);
export default __webpack_public_path__ + "static/media/messenger-redesign.e8766eb23fba51f00fe5ef75ed5c7f15.svg";
export { ForwardRef as ReactComponent };